import { createRouter, createWebHistory } from 'vue-router'
import AboutUsPageView from '@/views/AboutUsPageView.vue'
import CateringPageView from '@/views/CateringPageView.vue'
import HungrysPageView from '@/views/HungrysPageView.vue'
import HomePageView from '@/views/HomePageView.vue'
import VenuePageView from '@/views/VenuePageView.vue'
import ContactUsPageView from '@/views/ContactUsPageView.vue'
import WhealthyPageView from '@/views/WhealthyPageView.vue'



const router = createRouter({
  history: createWebHistory('/'),

  routes: [
    {
      path: '/',
      name: 'homepage',
      component: HomePageView,
    },
    
    {
      path: '/hungrys',
      name: 'hungrys',
      component: HungrysPageView,
    },
     {
      path: '/catering',
      name: 'catering',
      component: CateringPageView,
    },
     {
      path: '/venue',
      name: 'venue',
      component: VenuePageView,
    },
     {
      path: '/aboutus',
      name: 'aboutus',
      component: AboutUsPageView,
    },
     {
      path: '/contact',
      name: 'contact',
      component: ContactUsPageView,
    },
    {
  path: '/whealthy',
  name: 'whealthy',
  component: WhealthyPageView,
 
},
{
  path: '/samosa-house',
  name: 'SamosaHouse',

},
{
  path: '/chikos-chicken',
  name: 'ChikosChicken',
 
}
  ],
})

export default router
